import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "M7 22H4a2 2 0 0 1-2-2v-7a2 2 0 0 1 2-2h3zM20.3 9H14V5a3 3 0 0 0-3-3l-1 6-2 2v11h9.7a2 2 0 0 0 1.97-1.67l1.3-7A2 2 0 0 0 20.3 9" }, null, -1)
  ]))]))
}
export default { render: render }